import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MARKETPLACEHEROSLIDEIMAGEBLOCK_LEGACY_FIELD_ORDER = [
  "image"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  marketplaceHeroSlideImageBlockDescriptor: _generatedMarketplaceHeroSlideImageBlockDescriptor,
  marketplaceHeroSlideImageBlockBlocDefinition,
  marketplaceHeroSlideImageBlockDashboardLayout,
  marketplaceHeroSlideImageBlockConfig,
  marketplaceHeroSlideImageBlockResolveConfig,
  marketplaceHeroSlideImageBlockProperties,
} = doodBlockConfig(
  {
    name: "Marketplace hero - Slide image",
    componentType: 'MarketplaceHeroSlideImageBlockComponent',
    category: 'content',
    description: "Marketplace hero - Slide image.",
    keywords: [],
    allowedIn: [
      { bloc: "MarketplaceHeroBlockComponent", slot: "image_slides" },
    ],
    sharedFields: {}
  },

  () => ({
    image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.marketplace-hero-slide-image.image.label",
        help: "pages.blocks.marketplace-hero-slide-image.image.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.marketplace-hero-slide-image.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.marketplace-hero-slide-image.fieldset.image.label",
            fields: ["image"],
          },
        ],
      },
    ],
  })
);

export function marketplaceHeroSlideImageBlockDescriptor(): IBlockDescriptor;
export function marketplaceHeroSlideImageBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function marketplaceHeroSlideImageBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedMarketplaceHeroSlideImageBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedMarketplaceHeroSlideImageBlockDescriptor, marketplaceHeroSlideImageBlockProperties, fieldOrder);
}

export {
  marketplaceHeroSlideImageBlockBlocDefinition,
  marketplaceHeroSlideImageBlockDashboardLayout,
  marketplaceHeroSlideImageBlockProperties,
  marketplaceHeroSlideImageBlockConfig,
  marketplaceHeroSlideImageBlockResolveConfig,
};

export type MarketplaceHeroSlideImageBlockConfig = typeof marketplaceHeroSlideImageBlockConfig;
